import Step13Page from "pages/Step13/Step13Page";
import Step1Pages from "../pages/Step1/Step1Pages";
import Step11Page from "../pages/Step11/Step11Page";
import Step2Pages from "../pages/Step2/Step2Pages";
import Step3Pages from "../pages/Step3/Step3Pages";
import Step4Pages from "../pages/Step4/Step4Pages";
import Step5Pages from "../pages/Step5/Step5Pages";
import Step6Pages from "../pages/Step6/Step6Pages";
import Step7Pages from "../pages/Step7/Step7Pages";
import Step8Pages from "../pages/Step8/Step8Pages";
import Step9Pages from "../pages/Step9/Step9Pages";
import Step14Page from "../pages/Step14/Step14Page";
import Step15Page from "pages/Step15/Step15Page";
import QuoterFormLayout from "layouts/QuoterFormLayout";

export const CotizadorRoutes = [
    {
        element: <QuoterFormLayout />,
        children: [
            {
                path: "/step1",
                element: <Step1Pages />
            },
            {
                path: "/step2",
                element: <Step2Pages />
            },
            {
                path: "/step3",
                element: <Step3Pages />
            },
            {
                path: "/step4",
                element: <Step4Pages />
            },
            {
                path: "/step5",
                element: <Step5Pages />
            },
            {
                path: "/step6",
                element: <Step6Pages />
            },
            {
                path: "/step7",
                element: <Step7Pages />
            },
            {
                path: "/step8",
                element: <Step8Pages />
            },
            {
                path: "/step9",
                element: <Step9Pages />
            },
            {
                path: "/step11",
                element: <Step11Page />
            },
            {
                path: "/step13",
                element: <Step13Page />
            },
            {
                path: "/step14",
                element: <Step14Page />
            },
            {
                path: "/step15",
                element: <Step15Page />
            }
        ]
    }
]